import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import ContactWidget from '../../components/feature/ContactWidget';

export default function HomePage() {
  const [isScrolled, setIsScrolled] = useState(false);

  // 监听滚动
  useEffect(() => {
    if (typeof window !== 'undefined') {
      const handleScroll = () => {
        setIsScrolled(window.scrollY > 50);
      };
      
      window.addEventListener('scroll', handleScroll);
      
      // 清理事件监听器
      return () => {
        window.removeEventListener('scroll', handleScroll);
      };
    }
  }, []);

  return (
    <div className="min-h-screen bg-white font-['Inter',sans-serif]">
      {/* 导航栏 */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md' : 'bg-transparent'}`}>
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <img src="https://static.readdy.ai/image/e08b640d8e1faa1c442b1e5d1bd82f9f/c6ce6deb9bd605bc30f00ede9c81fe0c.png" alt="WEIYU GLOBAL" className="h-16 w-auto" />
          </div>
          <div className="hidden md:flex items-center gap-8">
            <a href="#about" className={`text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${isScrolled ? 'text-gray-700 hover:text-[#1a2b4a]' : 'text-white hover:text-[#4a90e2]'}`}>About Us</a>
            <a href="#services" className={`text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${isScrolled ? 'text-gray-700 hover:text-[#1a2b4a]' : 'text-white hover:text-[#4a90e2]'}`}>Core Services</a>
            <a href="#process" className={`text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${isScrolled ? 'text-gray-700 hover:text-[#1a2b4a]' : 'text-white hover:text-[#4a90e2]'}`}>Service Process</a>
            <a href="#contact" className="bg-gradient-to-r from-[#1e5a9e] to-[#2874c7] text-white px-6 py-2.5 rounded-full text-sm font-medium hover:shadow-xl transition-all cursor-pointer whitespace-nowrap">Contact Us</a>
          </div>
        </div>
      </nav>

      {/* Hero 区域 */}
      <section className="relative min-h-screen flex items-center overflow-hidden">
        <div className="absolute inset-0">
          <img 
            src="https://public.readdy.ai/ai/img_res/7b3291f915dbf145bfb16a1160c53c83.jpg" 
            alt="Background" 
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-[#1a2b4a]/70 via-[#1a2b4a]/60 to-[#1a2b4a]/70"></div>
        </div>
        
        <div className="relative z-10 max-w-7xl mx-auto px-6 py-32 w-full">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div className="text-white">
              <div className="inline-block bg-gradient-to-r from-[#1e5a9e] to-[#2874c7] text-white px-5 py-2.5 rounded-full text-xs md:text-sm font-medium mb-6 shadow-lg">
                China Supply Chain Expert · Cross-border Sourcing Services
              </div>
              <h1 className="text-3xl md:text-7xl font-bold mb-6 leading-tight">
                Your Supply Chain<br />Partner in China
              </h1>
              <p className="text-base md:text-xl text-gray-200 font-light mb-4">
                Professional Sourcing | Quality Control | Risk Management | Project Execution
              </p>
              <p className="text-sm md:text-lg text-white mb-8 leading-relaxed">
                More than just finding factories - we systematically manage your China supply chain. Helping overseas clients save time, reduce communication costs, and minimize risks.
              </p>
              <div className="flex flex-wrap gap-4">
                <a href="#contact" className="bg-gradient-to-r from-[#1e5a9e] to-[#2874c7] text-white px-6 md:px-8 py-3 md:py-4 rounded-full text-base md:text-lg font-medium hover:shadow-xl transition-all flex items-center gap-2 cursor-pointer whitespace-nowrap">
                  Start Consultation
                  <i className="ri-arrow-right-line"></i>
                </a>
                <a href="#services" className="border-2 border-white text-white px-6 md:px-8 py-3 md:py-4 rounded-full text-base md:text-lg font-medium hover:bg-white hover:text-[#1a2b4a] transition-all cursor-pointer whitespace-nowrap">
                  View Case Studies
                </a>
              </div>
            </div>
            
            <div className="relative">
              <div className="bg-white/10 backdrop-blur-md rounded-3xl p-6 md:p-8 border border-white/20 shadow-2xl">
                <div className="flex items-center justify-between mb-6">
                  <div className="bg-gradient-to-r from-[#1e5a9e] to-[#2874c7] text-white px-4 md:px-5 py-2 md:py-2.5 rounded-full text-xs md:text-sm font-semibold shadow-lg">
                    Serving 200+ Global Clients
                  </div>
                </div>
                <div className="grid grid-cols-2 gap-4">
                  <div className="bg-white/20 backdrop-blur-sm rounded-2xl p-4 md:p-6 text-center">
                    <div className="text-4xl md:text-5xl font-bold text-white mb-2">8+</div>
                    <div className="text-gray-200 text-xs md:text-sm">Years Experience</div>
                  </div>
                  <div className="bg-white/20 backdrop-blur-sm rounded-2xl p-4 md:p-6 text-center">
                    <div className="text-4xl md:text-5xl font-bold text-white mb-2">95%</div>
                    <div className="text-gray-200 text-xs md:text-sm">Client Satisfaction</div>
                  </div>
                  <div className="bg-white/20 backdrop-blur-sm rounded-2xl p-4 md:p-6 text-center col-span-2">
                    <div className="text-4xl md:text-5xl font-bold text-white mb-2">15+</div>
                    <div className="text-gray-200 text-xs md:text-sm">Product Categories</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 关于 WEIYU GLOBAL */}
      <section id="about" className="py-24 bg-gradient-to-br from-gray-50 to-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid md:grid-cols-5 gap-12 items-center">
            <div className="md:col-span-2">
              <div className="relative rounded-3xl overflow-hidden shadow-2xl">
                <img 
                  src="https://static.readdy.ai/image/e08b640d8e1faa1c442b1e5d1bd82f9f/a44e09db8052da457c980ec0e2ac7ef2.png" 
                  alt="Founder" 
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute top-6 left-6">
                  <div className="bg-white text-[#1a2b4a] px-3 md:px-4 py-1.5 md:py-2 rounded-lg text-xs md:text-sm font-semibold shadow-lg">
                    WEIYU GLOBAL Founder
                  </div>
                </div>
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-[#1a2b4a]/90 to-transparent p-6">
                  <h3 className="text-white text-xl md:text-2xl font-bold">Owen Zeng</h3>
                  <p className="text-gray-200 text-sm md:text-base">Project Manager / Founder</p>
                </div>
              </div>
            </div>
            
            <div className="md:col-span-3">
              <div className="flex items-center gap-2 mb-4">
                <div className="w-2 h-2 bg-[#1e5a9e] rounded-full"></div>
                <span className="text-[#1e5a9e] font-medium text-sm md:text-base">About the Founder</span>
              </div>
              <h2 className="text-2xl md:text-5xl font-bold text-[#1a2b4a] mb-6">
                8 Years of China Supply Chain Expertise
              </h2>
              <div className="space-y-4 text-gray-700 text-sm md:text-lg leading-relaxed">
                <p>
                  As the founder and project manager of WEIYU GLOBAL, I specialize in providing professional China supply chain connection and management services for overseas clients. I deeply understand the complexity and challenges of cross-border sourcing, and I'm committed to being the most reliable local representative for my clients in China.
                </p>
                <p>
                  My core strength lies in systematic supply chain management - not just finding factories for clients, but more importantly, controlling project execution, quality standards, and risk management throughout the entire process. From supplier screening and sample tracking to mass production management, I ensure every step meets client expectations.
                </p>
                <p>
                  I serve clients across Europe, Africa, Asia, and beyond, covering DTC brands, SMEs, and startup projects. Whether it's customized products, OEM/ODM projects, or complex multi-supplier coordination, I provide professional solutions.
                </p>
              </div>
              
              <div className="grid grid-cols-3 gap-4 md:gap-8 mt-10 pt-10 border-t border-gray-300">
                <div>
                  <div className="text-3xl md:text-5xl font-bold text-[#1e5a9e] mb-2">200+</div>
                  <div className="text-gray-600 text-xs md:text-sm">Clients Served</div>
                </div>
                <div>
                  <div className="text-3xl md:text-5xl font-bold text-[#1e5a9e] mb-2">8+</div>
                  <div className="text-gray-600 text-xs md:text-sm">Years Experience</div>
                </div>
                <div>
                  <div className="text-3xl md:text-5xl font-bold text-[#1e5a9e] mb-2">15+</div>
                  <div className="text-gray-600 text-xs md:text-sm">Product Categories</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 核心服务 */}
      <section id="services" className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <div className="flex items-center justify-center gap-2 mb-4">
              <div className="w-2 h-2 bg-[#1e5a9e] rounded-full"></div>
            </div>
            <h2 className="text-2xl md:text-5xl font-bold text-[#1a2b4a] mb-4">
              Comprehensive Supply Chain Management Services
            </h2>
            <p className="text-base md:text-xl text-gray-600">
              More than finding factories - systematic management of your China supply chain
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {/* 卡片 1 */}
            <div className="bg-white rounded-3xl p-6 md:p-8 shadow-lg hover:shadow-2xl transition-all hover:-translate-y-2 border border-gray-100">
              <div className="w-14 h-14 md:w-16 md:h-16 bg-gradient-to-br from-[#1a2b4a] to-[#2d4a6f] rounded-2xl flex items-center justify-center mb-6">
                <i className="ri-building-line text-2xl md:text-3xl text-white"></i>
              </div>
              <h3 className="text-lg md:text-2xl font-bold text-[#1a2b4a] mb-4">Supplier Screening &amp; Assessment</h3>
              <p className="text-sm md:text-base text-gray-600 leading-relaxed mb-4">
                In-depth screening of quality suppliers, evaluating factory capabilities, production capacity, and quality systems. Multi-dimensional comparative analysis to ensure finding the most suitable partners.
              </p>
              <a href="#contact" className="text-[#1e5a9e] font-medium inline-flex items-center gap-1 cursor-pointer whitespace-nowrap hover:gap-2 transition-all text-sm md:text-base">
                Learn More <i className="ri-arrow-right-line"></i>
              </a>
            </div>

            {/* 卡片 2 */}
            <div className="bg-gradient-to-br from-[#1e5a9e] to-[#2874c7] rounded-3xl p-6 md:p-8 shadow-lg hover:shadow-2xl transition-all hover:-translate-y-2 text-white">
              <div className="w-14 h-14 md:w-16 md:h-16 bg-white rounded-2xl flex items-center justify-center mb-6">
                <i className="ri-pencil-ruler-2-line text-2xl md:text-3xl text-[#1e5a9e]"></i>
              </div>
              <h3 className="text-lg md:text-2xl font-bold mb-4">Custom Products &amp; OEM/ODM</h3>
              <p className="text-sm md:text-base text-white/90 leading-relaxed mb-4">
                Specialized in handling customized products and complex projects. From tech pack interpretation and sample tracking to mass production management, ensuring every detail meets your requirements.
              </p>
              <a href="#contact" className="text-white font-medium inline-flex items-center gap-1 cursor-pointer whitespace-nowrap hover:gap-2 transition-all text-sm md:text-base">
                Learn More <i className="ri-arrow-right-line"></i>
              </a>
            </div>

            {/* 卡片 3 */}
            <div className="bg-white rounded-3xl p-6 md:p-8 shadow-lg hover:shadow-2xl transition-all hover:-translate-y-2 border border-gray-100">
              <div className="w-14 h-14 md:w-16 md:h-16 bg-gradient-to-br from-[#1a2b4a] to-[#2d4a6f] rounded-2xl flex items-center justify-center mb-6">
                <i className="ri-shield-check-line text-2xl md:text-3xl text-white"></i>
              </div>
              <h3 className="text-lg md:text-2xl font-bold text-[#1a2b4a] mb-4">Quality Control &amp; Production Supervision</h3>
              <p className="text-sm md:text-base text-gray-600 leading-relaxed mb-4">
                Full-process production tracking, quality standard alignment, and pre-shipment inspection. Assisting with quality disputes and rework to ensure product quality.
              </p>
              <a href="#contact" className="text-[#1e5a9e] font-medium inline-flex items-center gap-1 cursor-pointer whitespace-nowrap hover:gap-2 transition-all text-sm md:text-base">
                Learn More <i className="ri-arrow-right-line"></i>
              </a>
            </div>

            {/* 卡片 4 */}
            <div className="bg-white rounded-3xl p-6 md:p-8 shadow-lg hover:shadow-2xl transition-all hover:-translate-y-2 border border-gray-100">
              <div className="w-14 h-14 md:w-16 md:h-16 bg-gradient-to-br from-[#1a2b4a] to-[#2d4a6f] rounded-2xl flex items-center justify-center mb-6">
                <i className="ri-file-list-3-line text-2xl md:text-3xl text-white"></i>
              </div>
              <h3 className="text-lg md:text-2xl font-bold text-[#1a2b4a] mb-4">Procurement Project Management</h3>
              <p className="text-sm md:text-base text-gray-600 leading-relaxed mb-4">
                Systematic procurement project management, coordinating factory communication, requirement clarification, quotation comparison, and cost analysis. Ensuring projects are completed on time and with quality.
              </p>
              <a href="#contact" className="text-[#1e5a9e] font-medium inline-flex items-center gap-1 cursor-pointer whitespace-nowrap hover:gap-2 transition-all text-sm md:text-base">
                Learn More <i className="ri-arrow-right-line"></i>
              </a>
            </div>

            {/* 卡片 5 */}
            <div className="bg-gradient-to-br from-gray-50 to-white rounded-3xl p-6 md:p-8 shadow-lg hover:shadow-2xl transition-all hover:-translate-y-2 border border-[#1e5a9e]/20">
              <div className="w-14 h-14 md:w-16 md:h-16 bg-gradient-to-br from-[#1e5a9e] to-[#2874c7] rounded-2xl flex items-center justify-center mb-6">
                <i className="ri-line-chart-line text-2xl md:text-3xl text-white"></i>
              </div>
              <h3 className="text-lg md:text-2xl font-bold text-[#1a2b4a] mb-4">Cost Optimization Analysis</h3>
              <p className="text-sm md:text-base text-gray-600 leading-relaxed mb-4">
                In-depth cost structure analysis, providing multi-option comparisons. Helping clients find the best balance between quality and cost.
              </p>
              <a href="#contact" className="text-[#1e5a9e] font-medium inline-flex items-center gap-1 cursor-pointer whitespace-nowrap hover:gap-2 transition-all text-sm md:text-base">
                Learn More <i className="ri-arrow-right-line"></i>
              </a>
            </div>

            {/* 卡片 6 */}
            <div className="bg-white rounded-3xl p-6 md:p-8 shadow-lg hover:shadow-2xl transition-all hover:-translate-y-2 border border-gray-100">
              <div className="w-14 h-14 md:w-16 md:h-16 bg-gradient-to-br from-[#1a2b4a] to-[#2d4a6f] rounded-2xl flex items-center justify-center mb-6">
                <i className="ri-ship-line text-2xl md:text-3xl text-white"></i>
              </div>
              <h3 className="text-lg md:text-2xl font-bold text-[#1a2b4a] mb-4">Logistics Coordination Support</h3>
              <p className="text-sm md:text-base text-gray-600 leading-relaxed mb-4">
                Assisting in selecting appropriate shipping solutions, coordinating factories, warehouses, and freight forwarders. Controlling delivery schedules and managing exceptional risks to ensure timely delivery.
              </p>
              <a href="#contact" className="text-[#1e5a9e] font-medium inline-flex items-center gap-1 cursor-pointer whitespace-nowrap hover:gap-2 transition-all text-sm md:text-base">
                Learn More <i className="ri-arrow-right-line"></i>
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* 供应链管理详细说明 */}
      <section className="py-24 bg-gradient-to-br from-gray-50 to-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid md:grid-cols-2 gap-16 items-center">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <div className="w-2 h-2 bg-[#1e5a9e] rounded-full"></div>
                <span className="text-[#1e5a9e] font-medium text-sm md:text-base">Supply Chain Management</span>
              </div>
              <h2 className="text-2xl md:text-5xl font-bold text-[#1a2b4a] mb-6">
                Systematic Management<br />of Your China Supply Chain
              </h2>
              <p className="text-sm md:text-lg text-gray-700 leading-relaxed mb-6">
                We're not a simple "factory finding" service, but provide comprehensive supply chain management solutions. From supplier screening to final delivery, every step is professionally controlled.
              </p>
              <div className="space-y-4">
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 md:w-12 md:h-12 bg-gradient-to-br from-[#1e5a9e] to-[#2874c7] rounded-xl flex items-center justify-center flex-shrink-0">
                    <i className="ri-check-line text-xl md:text-2xl text-white"></i>
                  </div>
                  <div>
                    <h4 className="text-base md:text-xl font-bold text-[#1a2b4a] mb-2">Save Time Costs</h4>
                    <p className="text-sm md:text-base text-gray-600">No need to spend extensive time finding and connecting with suppliers - we complete all tedious work for you.</p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 md:w-12 md:h-12 bg-gradient-to-br from-[#1e5a9e] to-[#2874c7] rounded-xl flex items-center justify-center flex-shrink-0">
                    <i className="ri-check-line text-xl md:text-2xl text-white"></i>
                  </div>
                  <div>
                    <h4 className="text-base md:text-xl font-bold text-[#1a2b4a] mb-2">Reduce Communication Costs</h4>
                    <p className="text-sm md:text-base text-gray-600">As your local representative, we eliminate language and cultural barriers, ensuring accurate information delivery.</p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 md:w-12 md:h-12 bg-gradient-to-br from-[#1e5a9e] to-[#2874c7] rounded-xl flex items-center justify-center flex-shrink-0">
                    <i className="ri-check-line text-xl md:text-2xl text-white"></i>
                  </div>
                  <div>
                    <h4 className="text-base md:text-xl font-bold text-[#1a2b4a] mb-2">Minimize Risks</h4>
                    <p className="text-sm md:text-base text-gray-600">With years of experience, we help you avoid common pitfalls and ensure smooth project execution.</p>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="relative">
              <div className="rounded-3xl overflow-hidden shadow-2xl">
                <img 
                  src="https://readdy.ai/api/search-image?query=Modern%20stylish%20warehouse%20interior%20with%20organized%20inventory%20and%20logistics%20operations%2C%20contemporary%20industrial%20design%20with%20warm%20lighting%2C%20professional%20supply%20chain%20management%20facility%2C%20clean%20minimalist%20aesthetic%2C%20sophisticated%20business%20environment%2C%20high-end%20photography%20with%20depth%20of%20field&width=800&height=1000&seq=supply-modern-004&orientation=portrait" 
                  alt="Supply Chain Management" 
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 定制产品与 OEM/ODM */}
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid md:grid-cols-2 gap-16 items-center">
            <div className="order-2 md:order-1">
              <div className="grid grid-cols-2 gap-6">
                <div className="rounded-3xl overflow-hidden shadow-xl hover:shadow-2xl transition-all">
                  <img 
                    src="https://readdy.ai/api/search-image?query=Premium%20lifestyle%20product%20photography%20with%20elegant%20minimalist%20design%2C%20high-end%20DTC%20brand%20aesthetic%2C%20soft%20natural%20lighting%2C%20clean%20white%20background%2C%20sophisticated%20composition%2C%20modern%20luxury%20item%2C%20professional%20commercial%20photography%2C%20refined%20details%20and%20textures&width=400&height=500&seq=product-premium-005&orientation=portrait" 
                    alt="DTC Product" 
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="rounded-3xl overflow-hidden shadow-xl mt-12 hover:shadow-2xl transition-all">
                  <img 
                    src="https://readdy.ai/api/search-image?query=Professional%20medical%20laboratory%20equipment%20and%20consumables%2C%20sterile%20clinical%20environment%2C%20precision%20healthcare%20products%2C%20clean%20minimalist%20composition%20with%20white%20surfaces%2C%20bright%20professional%20lighting%2C%20modern%20medical%20industry%20photography%2C%20sharp%20focus%20on%20quality&width=400&height=500&seq=product-medical-006&orientation=portrait" 
                    alt="Medical Supplies" 
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="rounded-3xl overflow-hidden shadow-xl -mt-12 hover:shadow-2xl transition-all">
                  <img 
                    src="https://readdy.ai/api/search-image?query=Luxury%20home%20textile%20products%20with%20soft%20fabric%20textures%2C%20elegant%20neutral%20color%20palette%2C%20cozy%20interior%20styling%2C%20natural%20window%20light%2C%20minimalist%20contemporary%20home%20decor%2C%20premium%20cotton%20and%20linen%20materials%2C%20warm%20inviting%20atmosphere%2C%20lifestyle%20photography&width=400&height=500&seq=product-textile-007&orientation=portrait" 
                    alt="Textile Products" 
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="rounded-3xl overflow-hidden shadow-xl hover:shadow-2xl transition-all">
                  <img 
                    src="https://readdy.ai/api/search-image?query=Industrial%20machinery%20components%20and%20precision-engineered%20metal%20parts%2C%20professional%20workshop%20environment%2C%20technical%20equipment%20close-up%2C%20clean%20metallic%20surfaces%20and%20finishes%2C%20organized%20manufacturing%20setting%2C%20high-quality%20industrial%20photography%2C%20professional%20lighting&width=400&height=500&seq=product-industrial-008&orientation=portrait" 
                    alt="Industrial Parts" 
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>
            </div>
            
            <div className="order-1 md:order-2">
              <div className="flex items-center gap-2 mb-4">
                <div className="w-2 h-2 bg-[#1e5a9e] rounded-full"></div>
                <span className="text-[#1e5a9e] font-medium text-sm md:text-base">Custom Products &amp; OEM/ODM</span>
              </div>
              <h2 className="text-2xl md:text-5xl font-bold text-[#1a2b4a] mb-6">
                Professional Handling<br />of Complex Custom Projects
              </h2>
              <p className="text-sm md:text-lg text-gray-700 leading-relaxed mb-6">
                We specialize in handling high-requirement customized products and OEM/ODM projects. Whether it's materials, colors, processes, or standards, we precisely control every detail.
              </p>
              
              <div className="bg-gradient-to-br from-gray-50 to-white rounded-2xl p-4 md:p-6 mb-6 border border-gray-100">
                <h4 className="text-base md:text-xl font-bold text-[#1a2b4a] mb-4">Past Project Cases</h4>
                <div className="space-y-3">
                  <div className="flex items-center gap-3">
                    <div className="w-2 h-2 bg-[#1e5a9e] rounded-full flex-shrink-0"></div>
                    <span className="text-sm md:text-base text-gray-700">Premium DTC Brand Product Customization</span>
                  </div>
                  <div className="flex items-center gap-3">
                    <div className="w-2 h-2 bg-[#1e5a9e] rounded-full flex-shrink-0"></div>
                    <span className="text-sm md:text-base text-gray-700">Medical/Laboratory Consumables OEM Projects</span>
                  </div>
                  <div className="flex items-center gap-3">
                    <div className="w-2 h-2 bg-[#1e5a9e] rounded-full flex-shrink-0"></div>
                    <span className="text-sm md:text-base text-gray-700">Textile/Home Products Custom Development</span>
                  </div>
                  <div className="flex items-center gap-3">
                    <div className="w-2 h-2 bg-[#1e5a9e] rounded-full flex-shrink-0"></div>
                    <span className="text-sm md:text-base text-gray-700">Industrial Machinery Equipment &amp; Parts</span>
                  </div>
                  <div className="flex items-center gap-3">
                    <div className="w-2 h-2 bg-[#1e5a9e] rounded-full flex-shrink-0"></div>
                    <span className="text-sm md:text-base text-gray-700">Children's Winter Footwear Custom Sourcing</span>
                  </div>
                  <div className="flex items-center gap-3">
                    <div className="w-2 h-2 bg-[#1e5a9e] rounded-full flex-shrink-0"></div>
                    <span className="text-sm md:text-base text-gray-700">Premium Container Customization</span>
                  </div>
                  <div className="flex items-center gap-3">
                    <div className="w-2 h-2 bg-[#1e5a9e] rounded-full flex-shrink-0"></div>
                    <span className="text-sm md:text-base text-gray-700">Bulk Chemical Materials Procurement</span>
                  </div>
                  <div className="flex items-center gap-3">
                    <div className="w-2 h-2 bg-[#1e5a9e] rounded-full flex-shrink-0"></div>
                    <span className="text-sm md:text-base text-gray-700">Bulk Industrial Equipment Procurement</span>
                  </div>
                </div>
              </div>
              
              <p className="text-sm md:text-base text-gray-600 leading-relaxed">
                From tech pack interpretation to sample tracking, from mass production management to multi-supplier coordination, we provide full-process professional services.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* 质量控制 */}
      <section className="py-24 bg-gradient-to-br from-[#1a2b4a] to-[#2d4a6f] text-white relative overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-0 left-0 w-full h-full" style={{
            backgroundImage: 'radial-gradient(circle, #fff 1px, transparent 1px)',
            backgroundSize: '50px 50px'
          }}></div>
        </div>
        
        <div className="relative z-10 max-w-7xl mx-auto px-6">
          <div className="grid md:grid-cols-2 gap-16 items-center">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <div className="w-2 h-2 bg-[#4a90e2] rounded-full"></div>
                <span className="text-[#4a90e2] font-medium">Quality Control</span>
              </div>
              <h2 className="text-2xl md:text-5xl font-bold mb-6">
                Strict Control<br />of Every Production Stage
              </h2>
              <p className="text-sm md:text-lg text-gray-300 leading-relaxed mb-8">
                Quality control is the core of our service. We not only help you place orders, but more importantly, supervise the entire production process to ensure the final product meets your standards.
              </p>
              
              <div className="grid grid-cols-2 gap-6">
                <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20">
                  <div className="text-4xl font-bold text-[#4a90e2] mb-2">100%</div>
                  <div className="text-gray-300 text-sm">Pre-shipment Inspection</div>
                </div>
                <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20">
                  <div className="text-4xl font-bold text-[#4a90e2] mb-2">24h</div>
                  <div className="text-gray-300 text-sm">Issue Response Time</div>
                </div>
                <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20">
                  <div className="text-4xl font-bold text-[#4a90e2] mb-2">98%</div>
                  <div className="text-gray-300 text-sm">First-time Pass Rate</div>
                </div>
                <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20">
                  <div className="text-4xl font-bold text-[#4a90e2] mb-2">0</div>
                  <div className="text-gray-300 text-sm">Major Quality Incidents</div>
                </div>
              </div>
            </div>
            
            <div>
              <div className="space-y-6">
                <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20 hover:bg-white/15 transition-all">
                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 bg-gradient-to-br from-[#1e5a9e] to-[#2874c7] rounded-xl flex items-center justify-center flex-shrink-0">
                      <i className="ri-eye-line text-2xl text-white"></i>
                    </div>
                    <div>
                      <h4 className="text-lg md:text-xl font-bold mb-2">Production Process Tracking</h4>
                      <p className="text-gray-300">Real-time monitoring of production progress, timely identification and resolution of issues, ensuring on-time delivery.</p>
                    </div>
                  </div>
                </div>
                
                <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20 hover:bg-white/15 transition-all">
                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 bg-gradient-to-br from-[#1e5a9e] to-[#2874c7] rounded-xl flex items-center justify-center flex-shrink-0">
                      <i className="ri-checkbox-circle-line text-2xl text-white"></i>
                    </div>
                    <div>
                      <h4 className="text-lg md:text-xl font-bold mb-2">Quality Standard Alignment</h4>
                      <p className="text-gray-300">Clarifying quality requirements with factories, establishing inspection standards, ensuring products meet expectations.</p>
                    </div>
                  </div>
                </div>
                
                <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20 hover:bg-white/15 transition-all">
                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 bg-gradient-to-br from-[#1e5a9e] to-[#2874c7] rounded-xl flex items-center justify-center flex-shrink-0">
                      <i className="ri-shield-check-line text-2xl text-white"></i>
                    </div>
                    <div>
                      <h4 className="text-lg md:text-xl font-bold mb-2">Pre-shipment Inspection</h4>
                      <p className="text-gray-300">Strict pre-shipment quality inspection, timely handling of issues, avoiding subsequent disputes.</p>
                    </div>
                  </div>
                </div>
                
                <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20 hover:bg-white/15 transition-all">
                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 bg-gradient-to-br from-[#1e5a9e] to-[#2874c7] rounded-xl flex items-center justify-center flex-shrink-0">
                      <i className="ri-customer-service-2-line text-2xl text-white"></i>
                    </div>
                    <div>
                      <h4 className="text-lg md:text-xl font-bold mb-2">Dispute Resolution Support</h4>
                      <p className="text-gray-300">Assisting with quality disputes and rework, protecting your rights, ensuring issues are properly resolved.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 物流与交付协调 */}
      <section className="py-24 bg-gradient-to-br from-gray-50 to-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <div className="flex items-center justify-center gap-2 mb-4">
              <div className="w-2 h-2 bg-[#1e5a9e] rounded-full"></div>
              <span className="text-[#1e5a9e] font-medium">Logistics &amp; Delivery Coordination</span>
            </div>
            <h2 className="text-2xl md:text-5xl font-bold text-[#1a2b4a] mb-4">
              Ensuring On-time Delivery<br />Controlling Logistics Risks
            </h2>
            <p className="text-base md:text-xl text-gray-600 max-w-3xl mx-auto">
              We don't just book shipments - we coordinate the entire logistics chain, from factory to your warehouse, with professional control at every step
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            <div className="bg-white rounded-3xl p-8 shadow-lg hover:shadow-2xl transition-all hover:-translate-y-2">
              <div className="w-16 h-16 bg-gradient-to-br from-[#1e5a9e]/10 to-[#2874c7]/10 rounded-2xl flex items-center justify-center mb-6">
                <i className="ri-route-line text-3xl text-[#1e5a9e]"></i>
              </div>
              <h3 className="text-xl md:text-2xl font-bold text-[#1a2b4a] mb-4">Shipping Solution Selection</h3>
              <p className="text-gray-600 leading-relaxed">
                Based on your needs and budget, assisting in selecting the most suitable shipping solution (sea/air/express), balancing cost and timeliness.
              </p>
            </div>

            <div className="bg-white rounded-3xl p-8 shadow-lg hover:shadow-2xl transition-all hover:-translate-y-2">
              <div className="w-16 h-16 bg-gradient-to-br from-[#1e5a9e]/10 to-[#2874c7]/10 rounded-2xl flex items-center justify-center mb-6">
                <i className="ri-team-line text-3xl text-[#1e5a9e]"></i>
              </div>
              <h3 className="text-xl md:text-2xl font-bold text-[#1a2b4a] mb-4">Multi-party Coordination Management</h3>
              <p className="text-gray-600 leading-relaxed">
                Coordinating factories, warehouses, freight forwarders, and other resources, ensuring smooth information flow, avoiding delays caused by communication barriers.
              </p>
            </div>

            <div className="bg-white rounded-3xl p-8 shadow-lg hover:shadow-2xl transition-all hover:-translate-y-2">
              <div className="w-16 h-16 bg-gradient-to-br from-[#1e5a9e]/10 to-[#2874c7]/10 rounded-2xl flex items-center justify-center mb-6">
                <i className="ri-time-line text-3xl text-[#1e5a9e]"></i>
              </div>
              <h3 className="text-xl md:text-2xl font-bold text-[#1a2b4a] mb-4">Delivery Risk Control</h3>
              <p className="text-gray-600 leading-relaxed">
                Real-time tracking of logistics progress, early warning of potential risks, timely adjustment of plans, ensuring on-time delivery.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* 服务流程 */}
      <section id="process" className="py-24 bg-gradient-to-br from-[#1a2b4a] to-[#2d4a6f] relative overflow-hidden">
        <div className="absolute inset-0 opacity-5">
          <div className="absolute top-0 left-0 w-full h-full" style={{
            backgroundImage: 'radial-gradient(circle, #fff 1px, transparent 1px)',
            backgroundSize: '50px 50px'
          }}></div>
        </div>
        
        <div className="relative z-10 max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <span className="text-[#4a90e2] font-medium">Our Work Process</span>
            <h2 className="text-2xl md:text-5xl font-bold text-white mt-4 mb-4">
              Complete Closed Loop from Requirements to Delivery
            </h2>
          </div>

          <div className="grid md:grid-cols-5 gap-6">
            <div className="bg-white rounded-3xl p-8 relative hover:shadow-2xl transition-all">
              <div className="w-16 h-16 bg-gradient-to-br from-[#1e5a9e] to-[#2874c7] rounded-full flex items-center justify-center text-white text-2xl font-bold mb-6 shadow-lg">
                01
              </div>
              <h3 className="text-lg md:text-xl font-bold text-[#1a2b4a] mb-3">Requirement Communication &amp; Analysis</h3>
              <p className="text-gray-600 leading-relaxed">
                In-depth understanding of your needs, analyzing product specifications and quality standards, developing sourcing plans.
              </p>
              <div className="hidden md:block absolute -right-3 top-1/2 transform -translate-y-1/2">
                <i className="ri-arrow-right-line text-3xl text-[#4a90e2]"></i>
              </div>
            </div>

            <div className="bg-white rounded-3xl p-8 relative hover:shadow-2xl transition-all">
              <div className="w-16 h-16 bg-gradient-to-br from-[#1e5a9e] to-[#2874c7] rounded-full flex items-center justify-center text-white text-2xl font-bold mb-6 shadow-lg">
                02
              </div>
              <h3 className="text-lg md:text-xl font-bold text-[#1a2b4a] mb-3">Supplier Screening &amp; Assessment</h3>
              <p className="text-gray-600 leading-relaxed">
                Screening quality suppliers, evaluating factory capabilities, conducting quotation comparison and cost analysis.
              </p>
              <div className="hidden md:block absolute -right-3 top-1/2 transform -translate-y-1/2">
                <i className="ri-arrow-right-line text-3xl text-[#4a90e2]"></i>
              </div>
            </div>

            <div className="bg-white rounded-3xl p-8 relative hover:shadow-2xl transition-all">
              <div className="w-16 h-16 bg-gradient-to-br from-[#1e5a9e] to-[#2874c7] rounded-full flex items-center justify-center text-white text-2xl font-bold mb-6 shadow-lg">
                03
              </div>
              <h3 className="text-lg md:text-xl font-bold text-[#1a2b4a] mb-3">Sampling &amp; Confirmation</h3>
              <p className="text-gray-600 leading-relaxed">
                Tracking the sampling process, ensuring samples meet requirements, proceeding to mass production after your confirmation.
              </p>
              <div className="hidden md:block absolute -right-3 top-1/2 transform -translate-y-1/2">
                <i className="ri-arrow-right-line text-3xl text-[#4a90e2]"></i>
              </div>
            </div>

            <div className="bg-white rounded-3xl p-8 relative hover:shadow-2xl transition-all">
              <div className="w-16 h-16 bg-gradient-to-br from-[#1e5a9e] to-[#2874c7] rounded-full flex items-center justify-center text-white text-2xl font-bold mb-6 shadow-lg">
                04
              </div>
              <h3 className="text-lg md:text-xl font-bold text-[#1a2b4a] mb-3">Production Supervision &amp; Management</h3>
              <p className="text-gray-600 leading-relaxed">
                Full-process production progress tracking, quality control supervision, timely handling of production issues.
              </p>
              <div className="hidden md:block absolute -right-3 top-1/2 transform -translate-y-1/2">
                <i className="ri-arrow-right-line text-3xl text-[#4a90e2]"></i>
              </div>
            </div>

            <div className="bg-white rounded-3xl p-8 hover:shadow-2xl transition-all">
              <div className="w-16 h-16 bg-gradient-to-br from-[#1e5a9e] to-[#2874c7] rounded-full flex items-center justify-center text-white text-2xl font-bold mb-6 shadow-lg">
                05
              </div>
              <h3 className="text-lg md:text-xl font-bold text-[#1a2b4a] mb-3">Quality Inspection &amp; Delivery</h3>
              <p className="text-gray-600 leading-relaxed">
                Executing pre-shipment inspection, coordinating logistics arrangements, ensuring products are delivered on time and with quality.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* 客户评价 */}
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <div className="flex items-center justify-center gap-2 mb-4">
              <div className="w-2 h-2 bg-[#1e5a9e] rounded-full"></div>
            </div>
            <span className="text-gray-600">Client Feedback</span>
            <h2 className="text-2xl md:text-5xl font-bold text-[#1a2b4a] mt-4 mb-4">
              They Choose to Trust Us
            </h2>
            <p className="text-base md:text-xl text-gray-600">Real testimonials from global clients</p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            <div className="bg-gradient-to-br from-gray-50 to-white rounded-3xl p-8 shadow-lg hover:shadow-2xl transition-all hover:-translate-y-2 border border-gray-100">
              <div className="flex gap-1 mb-4">
                {[1, 2, 3, 4, 5].map((star) => (
                  <i key={star} className="ri-star-fill text-[#1e5a9e] text-xl"></i>
                ))}
              </div>
              <h4 className="text-lg md:text-xl font-bold text-[#1a2b4a] mb-3">Fast Response, Reliable Quality</h4>
              <p className="text-gray-600 leading-relaxed mb-6">
                Owen responds quickly and keeps quality standards high. Very professional and trustworthy partner.
              </p>
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 bg-gradient-to-br from-[#1e5a9e] to-[#2874c7] rounded-full flex items-center justify-center">
                  <span className="text-white font-bold">JM</span>
                </div>
                <div>
                  <div className="font-bold text-[#1a2b4a]">James Miller</div>
                  <div className="text-sm text-gray-500">DTC Brand Founder · UK</div>
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-br from-gray-50 to-white rounded-3xl p-8 shadow-lg hover:shadow-2xl transition-all hover:-translate-y-2 border border-gray-100">
              <div className="flex gap-1 mb-4">
                {[1, 2, 3, 4, 5].map((star) => (
                  <i key={star} className="ri-star-fill text-[#1e5a9e] text-xl"></i>
                ))}
              </div>
              <h4 className="text-lg md:text-xl font-bold text-[#1a2b4a] mb-3">Excellent Quality Control</h4>
              <p className="text-gray-600 leading-relaxed mb-6">
                Quality control is outstanding. Every shipment is carefully inspected. We trust Owen completely.
              </p>
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 bg-gradient-to-br from-[#1e5a9e] to-[#2874c7] rounded-full flex items-center justify-center">
                  <span className="text-white font-bold">MC</span>
                </div>
                <div>
                  <div className="font-bold text-[#1a2b4a]">Maria Costa</div>
                  <div className="text-sm text-gray-500">E-commerce Manager · Portugal</div>
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-br from-gray-50 to-white rounded-3xl p-8 shadow-lg hover:shadow-2xl transition-all hover:-translate-y-2 border border-gray-100">
              <div className="flex gap-1 mb-4">
                {[1, 2, 3, 4, 5].map((star) => (
                  <i key={star} className="ri-star-fill text-[#1e5a9e] text-xl"></i>
                ))}
              </div>
              <h4 className="text-lg md:text-xl font-bold text-[#1a2b4a] mb-3">Highly Efficient &amp; Professional</h4>
              <p className="text-gray-600 leading-relaxed mb-6">
                Very efficient communication and professional service. Owen handles everything smoothly.
              </p>
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 bg-gradient-to-br from-[#1e5a9e] to-[#2874c7] rounded-full flex items-center justify-center">
                  <span className="text-white font-bold">TP</span>
                </div>
                <div>
                  <div className="font-bold text-[#1a2b4a]">Thomas Petit</div>
                  <div className="text-sm text-gray-500">Project Manager · France</div>
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-br from-gray-50 to-white rounded-3xl p-8 shadow-lg hover:shadow-2xl transition-all hover:-translate-y-2 border border-gray-100">
              <div className="flex gap-1 mb-4">
                {[1, 2, 3, 4, 5].map((star) => (
                  <i key={star} className="ri-star-fill text-[#1e5a9e] text-xl"></i>
                ))}
              </div>
              <h4 className="text-lg md:text-xl font-bold text-[#1a2b4a] mb-3">Trustworthy Partner</h4>
              <p className="text-gray-600 leading-relaxed mb-6">
                Owen is reliable and always delivers on promises. Great quality control and communication.
              </p>
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 bg-gradient-to-br from-[#1e5a9e] to-[#2874c7] rounded-full flex items-center justify-center">
                  <span className="text-white font-bold">AD</span>
                </div>
                <div>
                  <div className="font-bold text-[#1a2b4a]">Ahmed Diallo</div>
                  <div className="text-sm text-gray-500">Importer · Senegal</div>
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-br from-gray-50 to-white rounded-3xl p-8 shadow-lg hover:shadow-2xl transition-all hover:-translate-y-2 border border-gray-100">
              <div className="flex gap-1 mb-4">
                {[1, 2, 3, 4, 5].map((star) => (
                  <i key={star} className="ri-star-fill text-[#1e5a9e] text-xl"></i>
                ))}
              </div>
              <h4 className="text-lg md:text-xl font-bold text-[#1a2b4a] mb-3">Quick Response Time</h4>
              <p className="text-gray-600 leading-relaxed mb-6">
                Always responds quickly to our questions. Very efficient and professional service.
              </p>
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 bg-gradient-to-br from-[#1e5a9e] to-[#2874c7] rounded-full flex items-center justify-center">
                  <span className="text-white font-bold">RB</span>
                </div>
                <div>
                  <div className="font-bold text-[#1a2b4a]">Robert Brown</div>
                  <div className="text-sm text-gray-500">Procurement Director · USA</div>
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-br from-gray-50 to-white rounded-3xl p-8 shadow-lg hover:shadow-2xl transition-all hover:-translate-y-2 border border-gray-100">
              <div className="flex gap-1 mb-4">
                {[1, 2, 3, 4, 5].map((star) => (
                  <i key={star} className="ri-star-fill text-[#1e5a9e] text-xl"></i>
                ))}
              </div>
              <h4 className="text-lg md:text-xl font-bold text-[#1a2b4a] mb-3">Reliable Quality Standards</h4>
              <p className="text-gray-600 leading-relaxed mb-6">
                Quality is always consistent. Owen ensures every detail meets our standards.
              </p>
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 bg-gradient-to-br from-[#1e5a9e] to-[#2874c7] rounded-full flex items-center justify-center">
                  <span className="text-white font-bold">SJ</span>
                </div>
                <div>
                  <div className="font-bold text-[#1a2b4a]">Sophie Jensen</div>
                  <div className="text-sm text-gray-500">Product Manager · Denmark</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA 行动召唤 */}
      <section className="relative py-24 md:py-32 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-[#1a2b4a] via-[#2d4a6f] to-[#1a2b4a]">
          <div className="absolute inset-0 opacity-10">
            <div className="absolute top-0 left-0 w-full h-full" style={{
              backgroundImage: 'radial-gradient(circle, #fff 1px, transparent 1px)',
              backgroundSize: '50px 50px'
            }}></div>
          </div>
        </div>
        
        <div className="relative z-10 max-w-7xl mx-auto px-6">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl md:text-6xl font-bold text-white mb-6 leading-tight">
                Ready to Optimize<br />Your Supply Chain?
              </h2>
              <p className="text-lg md:text-2xl text-gray-300 font-light mb-4">
                Professional Team · Transparent Process · Reliable Delivery
              </p>
              <p className="text-base md:text-xl text-gray-400 mb-8">
                Let us be your supply chain partner in China
              </p>
              <a href="#contact" className="inline-flex items-center gap-4 bg-gradient-to-r from-[#1e5a9e] to-[#2874c7] text-white px-6 md:px-8 py-3 md:py-4 rounded-full text-base md:text-xl font-medium hover:shadow-2xl transition-all group cursor-pointer whitespace-nowrap">
                <span>Schedule Consultation Now</span>
                <div className="w-10 h-10 md:w-12 md:h-12 bg-white/20 rounded-full flex items-center justify-center group-hover:scale-110 transition-transform">
                  <i className="ri-arrow-right-line text-white text-lg md:text-xl"></i>
                </div>
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer id="contact" className="bg-gradient-to-br from-[#1e3a8a] to-[#1e40af] text-white relative overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-0 left-0 w-full h-full" style={{
            backgroundImage: 'radial-gradient(circle, #fff 2px, transparent 2px)',
            backgroundSize: '50px 50px'
          }}></div>
        </div>

        <div className="relative z-10 max-w-7xl mx-auto px-6 py-16">
          <div className="grid md:grid-cols-12 gap-12 mb-12">
            <div className="md:col-span-4">
              <div className="flex items-center gap-3 mb-6">
                <img src="https://static.readdy.ai/image/e08b640d8e1faa1c442b1e5d1bd82f9f/c6ce6deb9bd605bc30f00ede9c81fe0c.png" alt="WEIYU GLOBAL" className="h-12 w-auto brightness-0 invert" />
              </div>
              <p className="text-white/90 mb-6 leading-relaxed">
                Professional China supply chain management service provider, offering one-stop solutions including sourcing, quality control, and project management for global clients.
              </p>
              <div className="space-y-3">
                <div className="flex items-center gap-3">
                  <i className="ri-phone-line text-white"></i>
                  <a href="tel:+8618025450862" className="text-white/90 hover:text-white transition-colors">+86-18025450862</a>
                </div>
                <div className="flex items-center gap-3">
                  <i className="ri-mail-line text-white"></i>
                  <a href="mailto:info@wyglobal-trade.com" className="text-white/90 hover:text-white transition-colors">info@wyglobal-trade.com</a>
                </div>
                <div className="flex items-center gap-3">
                  <i className="ri-global-line text-white"></i>
                  <a href="http://www.wyglobal-trade.com" target="_blank" rel="noopener noreferrer" className="text-white/90 hover:text-white transition-colors">www.wyglobal-trade.com</a>
                </div>
              </div>
            </div>

            <div className="md:col-span-2">
              <h4 className="text-lg font-bold mb-4">Core Services</h4>
              <ul className="space-y-2">
                <li><a href="#services" className="text-white/80 hover:text-white transition-colors cursor-pointer">Procurement Management</a></li>
                <li><a href="#services" className="text-white/80 hover:text-white transition-colors cursor-pointer">Quality Control</a></li>
                <li><a href="#services" className="text-white/80 hover:text-white transition-colors cursor-pointer">Project Execution</a></li>
              </ul>
            </div>

            <div className="md:col-span-2">
              <h4 className="text-lg font-bold mb-4">Service Areas</h4>
              <ul className="space-y-2">
                <li><a href="#services" className="text-white/80 hover:text-white transition-colors cursor-pointer">Custom Products</a></li>
                <li><a href="#services" className="text-white/80 hover:text-white transition-colors cursor-pointer">OEM/ODM</a></li>
                <li><a href="#services" className="text-white/80 hover:text-white transition-colors cursor-pointer">Industrial Parts</a></li>
              </ul>
            </div>

            <div className="md:col-span-2">
              <h4 className="text-lg font-bold mb-4">Company Info</h4>
              <ul className="space-y-2">
                <li><a href="#about" className="text-white/80 hover:text-white transition-colors cursor-pointer">Team Introduction</a></li>
                <li><a href="#process" className="text-white/80 hover:text-white transition-colors cursor-pointer">Service Process</a></li>
                <li><a href="#services" className="text-white/80 hover:text-white transition-colors cursor-pointer">Success Cases</a></li>
              </ul>
            </div>

            <div className="md:col-span-2">
              <h4 className="text-lg font-bold mb-4">Contact Us</h4>
              <ul className="space-y-2">
                <li><a href="#contact" className="text-white/80 hover:text-white transition-colors cursor-pointer">Schedule Consultation</a></li>
                <li><a href="#contact" className="text-white/80 hover:text-white transition-colors cursor-pointer">Partnership Inquiry</a></li>
                <li><a href="#contact" className="text-white/80 hover:text-white transition-colors cursor-pointer">FAQ</a></li>
              </ul>
            </div>
          </div>

          <div className="border-t border-white/20 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
            <div className="text-sm text-white/80">
              © 2025 WEIYU GLOBAL. All rights reserved.
            </div>
            
            <div className="flex items-center gap-4">
              <a href="https://www.linkedin.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 border border-white/30 rounded-lg flex items-center justify-center hover:border-white hover:bg-white/10 transition-colors">
                <i className="ri-linkedin-fill text-lg"></i>
              </a>
              <a href="https://wa.me/8618025450862" target="_blank" rel="noopener noreferrer" className="w-10 h-10 border border-white/30 rounded-lg flex items-center justify-center hover:border-white hover:bg-white/10 transition-colors">
                <i className="ri-whatsapp-line text-lg"></i>
              </a>
              <a href="weixin://" className="w-10 h-10 border border-white/30 rounded-lg flex items-center justify-center hover:border-white hover:bg-white/10 transition-colors">
                <i className="ri-wechat-line text-lg"></i>
              </a>
              <a href="mailto:info@wyglobal-trade.com" className="w-10 h-10 border border-white/30 rounded-lg flex items-center justify-center hover:border-white hover:bg-white/10 transition-colors">
                <i className="ri-mail-line text-lg"></i>
              </a>
            </div>
          </div>
          
          <div className="mt-6 text-center">
            <a href="https://readdy.ai/?origin=logo" target="_blank" rel="noopener noreferrer" className="text-xs text-white/40 hover:text-white/60 transition-colors">Powered by Readdy</a>
          </div>
        </div>
      </footer>

      {/* 留言组件 */}
      <ContactWidget />
    </div>
  );
}
